module.exports = "<div class=\"snackbar\" [@snack-visibility]=\"snackVisibility\">\n    {{message}}\n  </div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/snackbar/snackbar.component.html
// module id = ./src/app/shared/components/snackbar/snackbar.component.html
// module chunks = main